<template>
  <div>
    <button class="middle-button button">...</button>
    <button class="button" @click="$emit('page-selected', pageCount-1)">{{pageCount-1}}</button>
    <button class="button" @click="$emit('page-selected', pageCount)">{{pageCount}}</button>
  </div>
</template>



<script>
export default {
  props: {
    curPage: Number,
    pageCount: Number
  }
};
</script>